var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellNotificationOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98516 8.63354C7.3257 5.56868 9.91628 3.25 13 3.25V3.25C16.0837 3.25 18.6743 5.56868 19.0148 8.63354L19.2876 11.0886C19.3071 11.2638 19.3168 11.3514 19.3283 11.4378C19.4648 12.4617 19.7982 13.4495 20.3102 14.3467C20.3534 14.4224 20.3988 14.498 20.4895 14.6491L21.1157 15.6928C21.7532 16.7553 22.072 17.2866 21.9384 17.7146C21.896 17.8504 21.8251 17.9757 21.7304 18.0819C21.4322 18.4167 20.8126 18.4167 19.5734 18.4167H6.42658C5.18742 18.4167 4.56784 18.4167 4.26958 18.0819C4.17491 17.9757 4.10401 17.8504 4.06161 17.7146C3.92802 17.2866 4.2468 16.7553 4.88434 15.6928L5.51054 14.6491C5.60122 14.498 5.64656 14.4224 5.68979 14.3467C6.20181 13.4495 6.53524 12.4617 6.67166 11.4378C6.68318 11.3514 6.69291 11.2638 6.71238 11.0886L6.98516 8.63354Z",
    stroke: "#FC7B52",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0215 20.883C10.4539 20.3748 9.93517 19.2227 9.75 18.4165H16.25C16.0648 19.2227 15.5461 20.3749 14.9785 20.883C14.4109 21.3911 13.7154 21.6665 13 21.6665C12.2846 21.6665 11.5891 21.3911 11.0215 20.883Z",
    fill: "#FC7B52",
    stroke: "#FC7B52",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNotificationOrange);
export default __webpack_public_path__ + "static/media/bell--notification--orange.7db41e71466090cb1553eda570b0b893.svg";
export { ForwardRef as ReactComponent };